import { MULTIPLE_FILTER_VALUE_SEPARATOR } from 'consts/filters/common/multipleFilterValueSeparator';

export const parseMultipleFilterValueIntoValue: (multipleFilterValue: string) => string = (
    multipleFilterValue,
) => {
    const [_, filterValue] = multipleFilterValue.split(MULTIPLE_FILTER_VALUE_SEPARATOR);
    return filterValue;
};
